import { Close, ErrorOutline } from '@mui/icons-material';
import { Avatar, Box, IconButton } from '@mui/material';
import { amber } from '@mui/material/colors';
import { styled } from '@mui/material/styles';
import { componentTokens } from '@peritasai/ui-shared';

export const WarningIconContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
}));

export const WarningIcon = styled(ErrorOutline)(({ theme }) => ({
  fontSize: '2rem',
  width: 24,
  height: 24,
  color: theme.palette.warning.main,
}));

export const WarningIconAvatar = styled(Avatar)(({ theme }) => ({
  width: 40,
  height: 40,
  backgroundColor: componentTokens.components.alert.warning.background,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  '& svg': {
    color: amber[900],
  },
}));

export const DialogCloseButton: React.FC<{ onClick: () => void }> = ({
  onClick,
}) => (
  <IconButton
    aria-label="close"
    onClick={onClick}
    sx={{ color: 'text.secondary' }}
  >
    <Close sx={{ width: 24, height: 24 }} />
  </IconButton>
);
